import { createSelector } from 'reselect';
import PortalIdParser from 'PortalIdParser';
import { getModuleSpec, getElements } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import { getTemplateErrors } from 'ContentEditorUI/redux/selectors/templateInfoSelectors';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
import { getTemplatePath } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getIsDragDropEmail } from 'EmailEditorUI/redux/selectors/emailCategoriesSelectors';
// @ts-expect-error no declarations found for module
import templateErrorIsMissingTemplate from 'ContentEditorUI/utils/templateErrorIsMissingTemplate';
import { basicSelectorWithStats } from 'ContentEditorUI/redux/selectors/helpers';
// @ts-expect-error no declarations found for module
import { getContentSchemaFlexAreas } from 'ContentEditorUI/redux/selectors/contentSchemaSelectors';
// @ts-expect-error no declarations found for module
import { getCustomWidgetDesignManagerUrl } from 'EmailEditorUI/utils/moduleUtils';
export const getEmailTemplateInfo = basicSelector(state => state.templateInfo);
export const getIsConvertibleToDd = createSelector([getEmailTemplateInfo], templateInfo => templateInfo.isConvertibleToDd || false);
export const getDesignManagerUrlForModule = basicSelectorWithStats((state, elementId) => {
  const element = getElements(state).get(elementId);
  const moduleSpec = getModuleSpec(state, element);
  return `${getCustomWidgetDesignManagerUrl(moduleSpec.id, element)}`;
});
export const getDesignManagerUrlForTemplate = basicSelector(state => {
  return `/design-manager/${PortalIdParser.get()}/code/p/${getTemplatePath(state)}`;
});
export const getHasTemplate = createSelector([getTemplateErrors, getTemplatePath, getIsDragDropEmail], (templateErrors, templatePath, isDragDropEmail) => {
  return (isDragDropEmail || templatePath) && !templateErrors.some(templateErrorIsMissingTemplate(templatePath));
});
export const getTemplateContainsFlexArea = createSelector([getContentSchemaFlexAreas], flexAreas => {
  return !!flexAreas && Object.keys(flexAreas).length > 0;
});
export const getCanUseFlexAreas = createSelector([getTemplateContainsFlexArea, getIsDragDropEmail], (templateContainsFlexArea, isDragDropEmail) => {
  return templateContainsFlexArea || isDragDropEmail;
});